import Model, { AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';

import type IntegrationsConfigurationModel from 'admin-panel/models/integrations/configuration';
import type { IntegrationConfig } from 'admin-panel/models/integrations/configuration';

export default class IntegrationsConfigurationRevisionModel extends Model {
  @belongsTo('integrations/configuration')
  declare configuration: AsyncBelongsTo<IntegrationsConfigurationModel>;

  @attr('number')
  declare version: number;

  @attr('nested-object')
  declare config: IntegrationConfig;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'integrations/configuration-revision': IntegrationsConfigurationRevisionModel;
  }
}
